import classNames from 'classnames/bind';
import React from 'react';
import { CompanyDocuments } from '../../../../models/CompanyDocuments';
import { TableConfiguration } from '../GroupedTableRow/GroupedTableRow.types';
import styles from './GroupedTableColumnFilters.module.scss';

interface GroupedTableColumnFiltersProps<TData> {
  data?: CompanyDocuments<TData>;
  config: TableConfiguration<TData>;
  noCaret?: boolean;
  onFilter?: (key: string, value: string | number) => void;
  filters?: Record<string, string | number>;
}

const cx = classNames.bind(styles);

const GroupedTableColumnFilters = <TData,>({
  config,
  noCaret,
  onFilter,
  filters,
  data,
}: GroupedTableColumnFiltersProps<TData>): React.ReactElement => {
  return (
    <tr className={cx('body')}>
      <th className={cx('caret-column-heading', { hidden: noCaret })} />
      {config.columns.map(({ filterRenderer: CellRenderer, ...column }) => (
        <th style={{ width: column.width }} key={column.dataKey}>
          {CellRenderer ? (
            <CellRenderer
              data={data}
              tableConfig={config}
              columnConfig={column}
              onFilter={(value) => onFilter?.(column.dataKey, value)}
              value={filters?.[column.dataKey]}
            />
          ) : null}
        </th>
      ))}
    </tr>
  );
};

export default GroupedTableColumnFilters;
